import React from 'react';
import { PapiAttachmentFile } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { FullViewVideoProps } from '../types';
import { Film } from './Film';

interface Props extends Omit<FullViewVideoProps, 'deviation' | 'source'> {
  attachment: PapiAttachmentFile;
}

/** Wraps full film view for use with PapiAttachmentFile (e.g. a deviation's additionalMedia). */
const FilmAttachment: React.FC<Props> = ({ attachment, ...props }) => {
  const multiVideo = useFlag('multi_video');
  if (!multiVideo) {
    return null;
  }

  return <Film source={attachment} {...props} />;
};
FilmAttachment.displayName = 'FilmAttachment';

export default FilmAttachment;
